import React from "react";
import delete_outline from "../../assets/img/delete_outline.png";
import square from "../../assets/img/plus-square.png";
import Icon from "../../assets/img/Icon.png";
import { NavLink } from "react-router-dom";
import "./UploadMedia.css";
import { StateContext } from "../../store/StateProvider";
import $ from "jquery";
const index = () => {
  const [state, dispatch] = StateContext();
  const SelectBoxHandler = () => {
    $(".popupmaxWidth").toggleClass("d-none");
  };
  const ClickHandler = (e) => {
    e.preventDefault();
    $(".popupmaxWidth").toggleClass("d-none");
  };
  return (
    <>
      <section id="upload-" className="upload- py-5">
        <div className="container-fluid max-width mx-auto">
          <div className="row">
            <div className="col-12">
              {/* creator1 */}
              <NavLink to="/creator/creator1" className="float-end">
                <img src={state.items.circle} alt="close button" />
              </NavLink>
            </div>
            <div className="col-10 mx-auto mt-5 pt-5 mx-0 d-flex justify-content-between flex-wrap">
              <div className="col-10 col-md-5 col-lg-3 mx-auto my-2 py-5 ms-lg-0 upload-box-">
                <NavLink
                  to="/creator/UploadMedia1"
                  className="btn upload-btn- py-2"
                >
                  Upload MP3
                </NavLink>
                {/* <button type="submit" className="btn upload-btn- py-2">
                  Upload MP3
                </button> */}
              </div>
              <div className="col-10 col-md-5 col-lg-3 mx-auto my-2 py-5 upload-box-">
                <button type="submit" className="btn upload-btn- py-2">
                  Upload Zip
                </button>
              </div>
              <div className="col-10 col-md-6 col-lg-4 mx-auto my-2 py-5 me-lg-0 upload-box-">
                <button type="submit" className="btn upload-btn- py-2">
                  Ulpload Art (Jpeg, Png, Gif, Mp4)
                </button>
              </div>
            </div>
            <div className="col-10 mx-auto mt-5">
              <label
                htmlFor="text"
                className="text-white pb-3 upload-box1-label-"
              >
                Description
              </label>
              <textarea
                name="text"
                id=""
                className="form-control upload-box1-"
                defaultValue="Say somthing about your uploaded content"
              ></textarea>
            </div>
            <div className="col-10 mx-auto mt-5">
              <div className="row justify-content-between">
                <div className="col-md-5 my-2">
                  <label htmlFor="text" className="text-white pb-5"></label>
                  <input
                    type="text"
                    className="form-select upload-box2- SelectBox"
                    value="Genre"
                    onClick={SelectBoxHandler}
                  />
                </div>
                <div className="col-md-5 my-2">
                  <label
                    htmlFor="datetime-local"
                    className="upload-box3-text- pb-4 fw-light"
                  >
                    Drop Date & Time
                  </label>
                  <div className="upload-placeholder-">
                    <input type="text" className="upload-box3-  form-control" />
                    <div className="placeholder-datetime-">
                      <input
                        type="date"
                        className="upload-btn-background-"
                        placeholder="10-12-2022"
                      />
                      <input
                        type="time"
                        className="upload-btn-background- me-3"
                        placeholder="04:00 PM"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-10 mx-auto mt-md-5">
              <div className="row justify-content-between">
                <div className="col-md-5 my-2">
                  <label
                    htmlFor="datetime-local"
                    className="upload-box3-text- pb-3"
                  >
                    # of Edition NFTs
                  </label>
                  <input
                    type="text"
                    className="upload-box3- form-control"
                    placeholder="05"
                  />
                </div>
                <div className="col-md-5 my-2">
                  <label
                    htmlFor="datetime-local"
                    className="upload-box3-text- pb-3"
                  >
                    Edition NFT Mint Price
                  </label>
                  <input
                    type="text"
                    className="upload-box3- form-control"
                    placeholder="1233.79"
                  />
                </div>
              </div>
            </div>
            <div className="col-10 mt-md-5 mx-auto">
              <div className="row justify-content-between">
                <div className="col-md-5 mt-5 mt-md-0">
                  <div className="d-flex justify-content-between pb-3">
                    <div className="upload-box3-text- pb-3">Wallet Address</div>
                    <div>
                      <img src={square} alt="plus sign" />
                    </div>
                  </div>
                  {/* <!-- table start --> */}
                  <div className="col-sm-12">
                    <table className="table table-bordered table-text-">
                      <thead className="table-head-color-">
                        <tr>
                          <th></th>
                          <th>Address</th>
                          <th>Share</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody className="table-body-text-">
                        <tr>
                          <th>1</th>
                          <td>xxxx-yyyy-0101-jjjjs</td>
                          <td>9.5%</td>
                          <td>
                            <a href="/">
                              <img src={delete_outline} alt="delete icon" />
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <th>2</th>
                          <td>0202-8693-kkkp-pppk</td>
                          <td>2.5%</td>
                          <td>
                            <a href="/">
                              <img src={delete_outline} alt="delete icon" />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* <!-- table End --> */}
                </div>
                <div className="col-md-5 my-2 mt-md-5 pt-md-4">
                  <div className="d-flex pt-2 flex-column">
                    <label className="upload-box3-text- pb-3">
                      Shareable Link
                    </label>
                    <div className="upload-box3- d-flex px-2 py-1 justify-content-between align-items-center">
                      <div className="table-body-text-">
                        wavpoint/share-the-link
                      </div>
                      <div>
                        <a href="/">
                          <img src={state.items.share} alt="share" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-10 max-width mx-auto mt-5">
              <div className="row">
                <div className="col-12">
                  <div className="SubmitBtnWrapper-">
                    <button className="SubmitBtn- py-2">
                      <span className="me-2">Submit</span>
                      <img src={Icon} alt="upload icon" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="container-fluid border">
        <div className="row">
          <div className="col-11 mx-auto popupmaxWidth py-5 mt-5"> */}
      <div className="popupmaxWidth shadow d-none">
        <ul className="popupList">
          <li>
            <a href="/" onClick={ClickHandler}>
              Hip Hop
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Trap/Drill/Grime
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              House
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Garage/2-Step/Breakbeat
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Techno
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Downtempo
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              R&B/Soul
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Pop
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Rock
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Country
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              World
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Reggaeton/Dancehall
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Classical
            </a>
          </li>
          <li>
            <a href="/" onClick={ClickHandler}>
              Other
            </a>
          </li>
        </ul>
      </div>
      {/* </div>
        </div>
      </section> */}
    </>
  );
};

export default index;
